<template>
  <div>
    <!---->
    <b-row>
      <b-col md="5" offset-md="3">
        <b-card no-body class="border mb-1">
          <b-card-body class="p-2 m-0 ">
            <b-card-title class="p-1 m-0 text-center ">{{ $t("roadmap.stage.organization-created") }}</b-card-title>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isSystemAndRoadmapTutorialStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.system-and-roadmap-tutorial") }}</b-card-title>

          <content-loading v-if="isSystemAndRoadmapTutorialLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionSystemAndRoadmapTutorial"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksSystemAndRoadmapTutorial" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementPlatformRoadmap" stage="SYSTEM_AND_ROADMAP_TUTORIAL" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isOrganizationDetailStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.organization-detail") }}</b-card-title>

          <content-loading v-if="isOrganizationDetailLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionOrganizationDetail"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksOrganizationDetail" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementPlatformRoadmap" stage="ORGANIZATION_DETAIL" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="3"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
      <b-col md="1" offset-md="4"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="6">
        <b-card no-body class="border mb-1" :class="isOrganizationHierarchyStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.organization-hierarchy") }}</b-card-title>
          <content-loading v-if="isOrganizationHierarchyLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionOrganizationHierarchy"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksOrganizationHierarchy" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementPlatformRoadmap" stage="ORGANIZATION_HIERARCHY" />
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card no-body class="border mb-1" :class="isThirdPartyStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.third-party") }}</b-card-title>
          <content-loading v-if="isThirdPartyLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionThirdParty"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksThirdParty" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementPlatformRoadmap" stage="THIRD_PARTY" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="9"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="6"> </b-col>
      <b-col md="6">
        <b-card no-body class="border mb-1" :class="isPlatformPolicyStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.platform-policy") }}</b-card-title>
          <content-loading v-if="isPlatformPolicyLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionPlatformPolicy"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksPlatformPolicy" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementPlatformRoadmap" stage="PLATFORM_POLICY" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <hr />
    <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
import RoadmapStageTaskForm from "./component/roadmap-stage-task-form";
const state = "managementPlatformRoadmap";

export default {
  components: { RoadmapStageTaskForm },
  data() {
    return {};
  },

  computed: {
    descriptionOrganizationDetail: {
      get() {
        return this.$store.getters[`${state}/descriptionOrganizationDetail`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionOrganizationDetail`, v);
      },
    },
    descriptionSystemAndRoadmapTutorial: {
      get() {
        return this.$store.getters[`${state}/descriptionSystemAndRoadmapTutorial`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionSystemAndRoadmapTutorial`, v);
      },
    },

    descriptionOrganizationHierarchy: {
      get() {
        return this.$store.getters[`${state}/descriptionOrganizationHierarchy`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionOrganizationHierarchy`, v);
      },
    },

    descriptionThirdParty: {
      get() {
        return this.$store.getters[`${state}/descriptionThirdParty`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionThirdParty`, v);
      },
    },
    descriptionPlatformPolicy: {
      get() {
        return this.$store.getters[`${state}/descriptionPlatformPolicy`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionPlatformPolicy`, v);
      },
    },

    //
    editedStages() {
      return this.$store.getters[`${state}/editedStages`];
    },
    isSystemAndRoadmapTutorialStageEdited() {
      return this.editedStages.includes("SYSTEM_AND_ROADMAP_TUTORIAL");
    },
    isOrganizationDetailStageEdited() {
      return this.editedStages.includes("ORGANIZATION_DETAIL");
    },
    isOrganizationHierarchyStageEdited() {
      return this.editedStages.includes("ORGANIZATION_HIERARCHY");
    },
    isThirdPartyStageEdited() {
      return this.editedStages.includes("THIRD_PARTY");
    },
    isPlatformPolicyStageEdited() {
      return this.editedStages.includes("PLATFORM_POLICY");
    },
    //
    isOrganizationDetailLoading() {
      return this.$store.getters[`${state}/isOrganizationDetailLoading`];
    },
    isSystemAndRoadmapTutorialLoading() {
      return this.$store.getters[`${state}/isSystemAndRoadmapTutorialLoading`];
    },
    isOrganizationHierarchyLoading() {
      return this.$store.getters[`${state}/isOrganizationHierarchyLoading`];
    },
    isThirdPartyLoading() {
      return this.$store.getters[`${state}/isThirdPartyLoading`];
    },
    isPlatformPolicyLoading() {
      return this.$store.getters[`${state}/isPlatformPolicyLoading`];
    },

    //
    tasks() {
      return this.$store.getters[`${state}/tasks`];
    },
    tasksSystemAndRoadmapTutorial() {
      return this.tasks.filter((i) => i.stage == "SYSTEM_AND_ROADMAP_TUTORIAL");
    },
    tasksOrganizationDetail() {
      return this.tasks.filter((i) => i.stage == "ORGANIZATION_DETAIL");
    },

    tasksOrganizationHierarchy() {
      return this.tasks.filter((i) => i.stage == "ORGANIZATION_HIERARCHY");
    },
    tasksThirdParty() {
      return this.tasks.filter((i) => i.stage == "THIRD_PARTY");
    },
    tasksPlatformPolicy() {
      return this.tasks.filter((i) => i.stage == "PLATFORM_POLICY");
    },
    //
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
  },
  mounted() {
    this.loadStages();
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    const answer = window.confirm("Do you really want to leave? you have unsaved changes!");
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  methods: {
    beforeUnload(e) {
      if (this.editedStages.length == 0) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },

    loadStages() {
      return this.$store.dispatch(`${state}/loadStages`);
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/save`);
        this.loadStages();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    removeTaskItem(task) {
      this.$store.commit(`${state}/removeTaskItem`, { task });
    },
    editTaskItem(task) {
      this.$store.commit(`${state}/editedTask`, { ...task });

      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task-` + task.stage);
    },
  },
};
</script>
